__webpack_require__.p = "/lukemind/";